// @flow
import red from "@material-ui/core/colors/red";
import CssBaseline from "@material-ui/core/CssBaseline";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { loadGlobals } from "common/globals/duck";
import * as globalsSelectors from "common/globals/selectors";
import ICPCLoader from "components/ICPCLoader";
import PublicAppFrame from "components/PublicAppFrame";
import ErrorBoundary from "containers/ErrorBoundary";
import { login, logout, register } from "containers/Security/duck";
import * as securitySelectors from "containers/Security/selectors";
import {
  hideMessage,
  showErrorMessageSimple,
  showErrorMessage,
  showMessage,
} from "containers/Snackbar/duck";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "connected-react-router/immutable";
import { createStructuredSelector } from "reselect";
import * as s from "./selectors";
import {
  resetNavbar,
  updatePersistent,
  updateScrollPercentage,
  updateShowScroll,
} from "./duck";
import { Redirect, Route, Switch } from "react-router-dom";
// Code-splitted imports
import Loadable from "react-loadable";
import EuropeFinderMap from "../../routes/public/EuropeFinderMap";
import NorthAmericaFinderMap from "../../routes/public/NorthAmericaFInderMap";
import SouthAmericaFinderMap from "../../routes/public/SouthAmericaFinderMap";
import AfricaFinderMap from "../../routes/public/AfricaFInderMap";
import type { Route as PublicRoute } from "types/Router";
import type { MenuItem } from "./types";

// const Home = Loadable({
//   loader: () => import("routes/public/Home"),
//   loading: ICPCLoader
// });
const Home2 = Loadable({
  loader: () => import("routes/public/Home2"),
  loading: ICPCLoader,
});
/*
const XWiki = Loadable({
  loader: () => import("routes/public/XWiki"),
  loading: ICPCLoader
});
const Journey = Loadable({
  loader: () => import("routes/public/Home/Journey.js"),
  loading: ICPCLoader
});
*/
const ICPCId = Loadable({
  loader: () => import("routes/public/ICPCID"),
  loading: ICPCLoader,
});
const HelpPublic = Loadable({
  loader: () => import("routes/public/HelpPublic"),
  loading: ICPCLoader,
});

const Privacy = Loadable({
  loader: () => import("routes/public/Privacy"),
  loading: ICPCLoader,
});
const WikiPage = Loadable({
  loader: () => import("routes/public/WikiPage"),
  loading: ICPCLoader,
});
const WFTeams = Loadable({
  loader: () => import("routes/public/WFTeams"),
  loading: ICPCLoader,
});
const Search = Loadable({
  loader: () => import("routes/public/Search"),
  loading: ICPCLoader,
});
const RegionalResults = Loadable({
  loader: () => import("routes/public/RegionalResults"),
  loading: ICPCLoader,
});
const RegionalFinderMap = Loadable({
  loader: () => import("routes/public/RegionalFinderMap"),
  loading: ICPCLoader,
});
const RegionalFinderContest = Loadable({
  loader: () => import("routes/public/RegionalFinderContest"),
  loading: ICPCLoader,
});

const UpcomingRegionals = Loadable({
  loader: () => import("routes/public/UpcomingRegionals"),
  loading: ICPCLoader,
});

const Questionnaire = Loadable({
  loader: () => import("routes/public/Questionnaire"),
  loading: ICPCLoader,
});

// const Login = Loadable({
//   loader: () => import("routes/public/Login"),
//   loading: ICPCLoader
// });

// const AddWikiPage = Loadable({
//   loader: () => import("routes/public/WikiPage/components/AddWikiPage"),
//   loading: ICPCLoader
// });

/**
 * PublicAppContainer - Our root component
 * This is where everything global lives, e.g.:
 * 1. Messaging (snackbar)
 * 2. Authentication/Authorization
 * 3. Top/bottom menu controls
 * 4. ...
 *
 * Look into duck.js for action creators you can dispatch anywhere in the app
 */

const theme = createMuiTheme({
  overrides: {
    MuiTableCell: {
      root: {
        /*whiteSpace: "normal",
         wordWrap: "break-word"*/
        overflow: "hidden",
      },
    },
    MuiCollapse: {
      container: {
        overflowX: "auto",
        overflowY: "hidden",
        // overflow: "visible"
      },
    },
  },
  palette: {
    primaryOriginal: {
      "50": "#e8feff",
      "100": "#d3ebf5",
      "200": "#a1c7e4",
      "300": "#74a1cf",
      "400": "#4c83c3",
      "500": "#2263aa",
      "600": "#185394",
      "700": "#164174",
      "800": "#113257",
      "900": "#0d2644",
      A100: "#47a9ff ",
      A200: "#2086fd ",
      A400: "#0e5cca ",
      A700: "#0d3d80i",
      contrastDefaultColor: "light",
    },

    primary: {
      light: "#44a0ff",
      main: "#0061cc",
      dark: "#003f8a",
      "50": "#e8feff",
      "100": "#c9efff",
      "200": "#c9efff",
      "300": "#44a0ff",
      "400": "#107eff",
      "500": "#0061cc",
      "600": "#0051ac",
      "700": "#003f8a",
      "800": "#003168",
      "900": "#002551",
      A100: "#47a9ff",
      A200: "#1e86ff",
      A400: "#0059d8",
      A700: "#003a8d",
      contrastDefaultColor: "light",
    },
    secondary: {
      light: "#90A4AE",
      main: "#607D8B",
      dark: "#455A64",
      "50": "#ECEFF1",
      "100": "#CFD8DC",
      "200": "#B0BEC5",
      "300": "#90A4AE",
      "400": "#78909C",
      "500": "#607D8B",
      "600": "#546E7A",
      "700": "#455A64",
      "800": "#37474F",
      "900": "#263238",
      A100: "#90A4AE",
      A200: "#78909C",
      A400: "#546E7A",
      A700: "#455A64",
      contrastDefaultColor: "light",
    },
    error: {
      light: red[300],
      main: red[500],
      dark: red[700],
      //red
    },
  },
});

const menuItems: Array<MenuItem> = [
  {
    name: "World Finals",
    link: "/worldfinals",
    links: [
      {
        name: "Schedule",
        link: "https://docs.icpc.global/wf-schedule/",
        newPage: true,
      },
      // {
      //   name: "Activities",
      //   link: "/activities",
      //   newPage: false,
      // },
      {
        name: "Online Judge",
        link: "https://judge.icpc.global",
        newPage: true,
      },
      {
        name: "Teams",
        link: "/teams",
        newPage: false,
      },
      {
        name: "World Finals Info",
        link: "https://worldfinals.icpc.global/",
        newPage: true,
      },
      {
        name: "World Finals Scoreboard",
        link: "https://scoreboard.icpc.global/2024",
        newPage: true,
      },
      {
        name: "World Finals Problems",
        link: "https://scoreboard.icpc.global/2024",
        newPage: true,
      },
      {
        name: "World Finals Rules",
        link: "/rules",
        newPage: false,
      },
      // cm5-2729: remove the online judge as the link is removed from the sysops team
      // {
      //   name: "Online Judge",
      //   link: "https://onlinejudge.icpc.global/public",
      //   newPage: true,
      // },
      {
        name: "Video/Photo Coverage",
        link: "https://news.icpc.global/",
        newPage: true,
      },
      {
        name: "World Finals Results",
        link: "/results",
        // link: "https://icpc.global/scoreboard",
        newPage: false,
        // noWiki: true,
      },
      {
        name: "Past Problems",
        link: "/past-problems",
        newPage: false,
      },
      // cm5-1930
      {
        name: "Fact Sheet",
        link: "https://icpc.global/worldfinals/fact-sheet/ICPC-Fact-Sheet.pdf",
        newPage: true,
      },
      {
        name: "Prog. Environment",
        link: "https://docs.icpc.global/worldfinals-programming-environment",
        newPage: true,
      },
      // {
      //   name: "Local Info",
      //   link: "http://c/",
      //   newPage: true,
      // },
      // added as per the request for 44th WF.
      // cm5-1789: removed as per the request.
      // {
      //   name: "Live Broadcast",
      //   link: "https://live.icpc.global/",
      //   newPage: true,
      // },
    ],
  },
  {
    name: "Regionals",
    link: "/regionals",
    links: [
      {
        name: "Region Finder",
        link: "/finder",
        newPage: false,
      },
      {
        name: "Upcoming Regionals",
        link: "/upcoming",
        newPage: false,
      },
      {
        name: "Regional Results",
        link: "/results",
        newPage: false,
      },
      {
        name: "Regional Rules",
        link: "/rules",
        newPage: false,
      },
      {
        name: "Getting Involved",
        link: "/get-involved",
        newPage: false,
      },
      {
        name: "Starting a Regional",
        link: "/start-contest",
        newPage: false,
      },
      {
        name: "Regional Contest Cookbook",
        link: "/regional-contest-cookbook",
        newPage: false,
      },
    ],
  },

  {
    name: "Compete",
    link: "/compete",
    links: [
      // {
      //   name: "Preparation",
      //   link: "/preparation",
      //   newPage: false,
      // },
      // {
      //   name: "Privacy Policy",
      //   link: "/privacy",
      //   newPage: false,
      //   noWiki: true,
      // },
      {
        name: "Policies and Procedures",
        link: "https://icpc.global/compete/policies-and-procedures/ICPC-Policies-and-Procedures.pdf",
        newPage: true,
      },
      {
        name: "Code of Ethics",
        link: "https://icpc.global/compete/code-of-ethics/ICPC-Code-of-Ethics.pdf",
        newPage: true,
      },
      {
        name: "FAQs",
        link: "/help",
        newPage: false,
        noWiki: true,
      },

      {
        name: "Problems",
        link: "/problems",
        newPage: false,
      },
      // {
      //   name: "Challenge",
      //   link: "/challenge",
      //   newPage: false,
      // },
    ],
  },
  {
    name: "Community",
    link: "/community",
    links: [
      {
        name: "Upsilon Pi Epsilon",
        link: "https://upe.acm.org/",
        newPage: true,
      },
      {
        name: "ICPC Tools",
        link: "https://tools.icpc.global/",
        newPage: true,
      },
      {
        name: "ICPC University",
        link: "https://u.icpc.global/",
        newPage: true,
      },
      {
        name: "ICPC Foundation",
        link: "http://icpc.foundation/",
        newPage: true,
      },
      {
        name: "History",
        link: "/history",
        newPage: false,
      },
      {
        name: "Contacts",
        link: "/contacts",
        newPage: false,
      },
    ],
  },
];

export type Props = {
  children: any,
  loggedIn: boolean,
  firstName: string,
  login: Function,
  logout: Function,
  register: Function,
  scrollPercentage: number,
  showScroll: boolean,
  persistent: boolean,
  worldFinalsYear: number,
  regionalsYear: number,
  videoStatus: string,
  videoName: string,
  worldFinalsContestId: number,
  isGlobalsLoading: number,
  isGlobalsError: number,
  redirect: (string) => void,
  loadGlobals: () => void,
  showMessage: (
    message: string,
    permanent?: boolean,
    duration?: number
  ) => void,
  hideMessage: () => void,
  updateScrollPercentage: (number) => void,
  updateShowScroll: (boolean) => void,
  updatePersistent: (boolean) => void,
  resetNavbar: () => void,
} & PublicRoute;

class PublicAppContainer extends Component<Props> {
  componentDidMount() {
    this.props.loadGlobals();
  }

  render() {
    const { children, ...other } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
          <PublicAppFrame
            isLoggedIn={this.props.loggedIn}
            name={this.props.firstName}
            persistent={this.props.persistent}
            login={this.props.login}
            logout={this.props.logout}
            register={this.props.register}
            redirect={this.props.redirect}
            match={this.props.match}
            showMessage={this.props.showMessage}
            hideMessage={this.props.hideMessage}
            menuItems={menuItems}
          >
            {!this.props.isGlobalsLoading && (
              <Switch>
                <Route
                  path="/"
                  exact
                  render={(route) => <Home2 {...other} {...route} />}
                />
                <Route
                  path="/ICPCID/:icpcId"
                  exact
                  render={(route) => <ICPCId {...other} {...route} />}
                />

                <Route
                  path="/regionals/upcoming"
                  exact
                  render={(route) => (
                    <UpcomingRegionals {...other} {...route} />
                  )}
                />

                <Route
                  path="/regionals/finder"
                  exact
                  render={(route) => (
                    <RegionalFinderMap {...other} {...route} />
                  )}
                />
                <Route
                  path="/regionals/finder/na"
                  exact
                  render={(route) => (
                    <NorthAmericaFinderMap {...other} {...route} />
                  )}
                />
                <Route
                  path="/regionals/finder/sa"
                  exact
                  render={(route) => (
                    <SouthAmericaFinderMap {...other} {...route} />
                  )}
                />
                <Route
                  path="/regionals/finder/eu"
                  exact
                  render={(route) => <EuropeFinderMap {...other} {...route} />}
                />
                <Route
                  path="/regionals/finder/af"
                  exact
                  render={(route) => <AfricaFinderMap {...other} {...route} />}
                />

                <Route
                  path="/regionals/finder/:id"
                  render={(route) => (
                    <RegionalFinderContest {...other} {...route} />
                  )}
                />

                <Route
                  exact
                  path="/regionals/results"
                  render={(route) => <RegionalResults {...other} {...route} />}
                />
                <Route
                  exact
                  path="/regionals/results/:urlyear"
                  render={(route) => <RegionalResults {...other} {...route} />}
                />

                <Route
                  path="/search/:query"
                  exact
                  render={(route) => <Search {...other} {...route} />}
                />

                <Route
                  path="/worldfinals/teams"
                  exact
                  render={(route) => <WFTeams {...other} {...route} />}
                />

                <Route
                  path="/help"
                  render={(route) => <HelpPublic {...other} {...route} />}
                />
                <Route
                  path="/privacy"
                  exact
                  render={(route) => <Privacy {...other} {...route} />}
                />

                <Route
                  path="/questionnaire/:token/:privateToken/:email"
                  exact
                  render={(route) => <Questionnaire {...other} {...route} />}
                />
                {/*<Route*/}
                {/*  path="/login"*/}
                {/*  render={route => <Login {...other} {...route} />}*/}
                {/*/>*/}
                {/* //todo: Remove if functionality to add page is not needed
                {/*<Route*/}
                {/*  path="/create-page"*/}
                {/*  exact*/}
                {/*  render={route => <AddWikiPage {...other} {...route} /> }*/}
                {/*/> */}
                <Route
                  path="/:space/:page"
                  exact
                  render={(route) => <WikiPage {...other} {...route} />}
                />
                <Redirect from="/faq" to="/help" />
              </Switch>
            )}
          </PublicAppFrame>
        </ErrorBoundary>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state: Object, props: Object) =>
  createStructuredSelector({
    loggedIn: securitySelectors.isLoggedIn,
    firstName: securitySelectors.getFirstName,
    userRoles: securitySelectors.getUserRoles,
    scrollPercentage: s.getScrollPercentage,
    showScroll: s.isShowScroll,
    persistent: s.isPersistent,
    worldFinalsYear: globalsSelectors.getWorldFinalsYear,
    regionalsYear: globalsSelectors.getRegionalsYear,
    videoStatus: globalsSelectors.getVideoStatus,
    videoName: globalsSelectors.getVideoName,
    worldFinalsContestId: globalsSelectors.getWorldFinalsContestId,
    isGlobalsLoading: globalsSelectors.isLoading,
    isGlobalsError: globalsSelectors.isError,
  });

/*
  This will bind our actions to dispatch (make the fire-able)
  and make the actions available via props
*/
export function mapDispatchToProps(dispatch: any) {
  return bindActionCreators(
    {
      redirect: push,
      updateScrollPercentage,
      updateShowScroll,
      resetNavbar,
      updatePersistent,
      loadGlobals,
      showMessage,
      showErrorMessageSimple,
      showErrorMessage,
      hideMessage,
      login,
      logout,
      register,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicAppContainer);
